import React, { useReducer, useContext } from 'react';
import ManagersContext from './ManagersContext';
import managersReducer from './ManagersReducer';
import axios from 'axios';
import {
  MANAGERS_ERROR,
  MANAGERS_LOOKUP,
  GET_MANAGERS,
  SET_LOADING,
  MANAGER_ERROR,
  UPDATE_MANAGER,
  CREATE_MANAGER,
  SET_CURRENT_MANAGER,
  CLEAR_SUCCESS,
  CLEAR_ERRORS,
  DELETE_MANAGER
  
} from '../types';

// Create a custom hook to use the customers context
export const useManagers = () => {
  const { state, dispatch } = useContext(ManagersContext);
  return [state, dispatch];
};

export const setLoading = (dispatch, isLoading) => dispatch({ type: SET_LOADING, payload: isLoading });

// Get Customers
export const getManagers = async (dispatch, page, text, sort) => {

  
  setLoading(dispatch, true)
  
  try {  
    
    const field = (sort.dir === 'desc') ? ('-' + sort.field) : sort.field;
    let query = '/v1/managers/?page=' + page + '&per-page=20&q=' + text + '&sort=' + field + '&customer_id=NULL';
  
    const res = await axios.get(query);
    
    dispatch({
      type: GET_MANAGERS,
      payload: res.data.data
    });
    
  } catch (err) {
    dispatch({
      type: MANAGER_ERROR,
      payload: err.response ?? 'ארעה שגיאה'//.msg
    });
  }

  setLoading(dispatch, false)
  
};

export const getLookup = async (dispatch) => {
  try {
    const res = await axios.get('/v1/lookup/managers');

    dispatch({
      type: MANAGERS_LOOKUP,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: MANAGERS_ERROR,
      payload: err.response// err.response//.msg
    });
  }
};

// Set Current Manager
export const setCurrent = (dispatch, manager) => {
  dispatch({ type: SET_CURRENT_MANAGER, payload: manager });
};


// Unset Current Manager
export const unsetCurrent = (dispatch) => {
  dispatch({ type: SET_CURRENT_MANAGER, payload: null });
};

export const updateManager = async (dispatch, manager) => {
  try {
    const res = await axios.put('/v1/managers/' + manager.id, manager);
    dispatch({
      type: UPDATE_MANAGER,
      payload: res.data.data
    });
  }
  catch (err) {
    dispatch({
      type: MANAGER_ERROR,
      payload: err.response
        ? err.response.data.title ?? "ארעה שגיאה"
        : "ארעה שגיאה",
    });
  }
};

export const deleteManager = async (dispatch, manager) => {
  try {
    const res = await axios.put('/v1/managers/' + manager.id, {active: false});
    console.log(res);
    dispatch({
      type: DELETE_MANAGER,
      payload: res.data.data
    });
  }
  catch (err) {
    dispatch({
      type: MANAGER_ERROR,
      payload: err.response ?? 'ארעה שגיאה'//.msg
    });
  }
};

export const createManager = async (dispatch, manager) => {
  try {
    const res = await axios.post('/v1/managers', {name: manager.name, email: manager.email, phone: manager.phone});
    dispatch({
      type: CREATE_MANAGER,
      payload: res.data.data
    });
  }
  catch (err) {
    console.log(err);
    dispatch({
      type: MANAGER_ERROR,
      payload: err.response
        ? err.response.data.title ?? "ארעה שגיאה"
        : "ארעה שגיאה",
    });
  }
};

export const clearSuccess = (dispatch) => dispatch({ type: CLEAR_SUCCESS });
export const clearErrors = (dispatch) => dispatch({ type: CLEAR_ERRORS });

const ManagersState = (props) => {
  const initialState = {
    managers: [],
    current: null,
    error: null,
    count: 0,
    labels: [],
    columns: [],
    actions: [],
    allManagers: [],
    loading: false,
    success: "",

  };
  const [state, dispatch] = useReducer(managersReducer, initialState);

  return (
    <ManagersContext.Provider value={{ state: state, dispatch }}>
      {props.children}
    </ManagersContext.Provider>
  );
};

export default ManagersState;